var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-empty-screen"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"logo",attrs:{"src":"/logo-white.svg"}}),_c('div',{staticClass:"text"},[_vm._v("\n      "+_vm._s(_vm.$t("screentimeParentingAlly"))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }